import { gql } from '@apollo/client';

export const SAVE_PARTNER_CONSENTS = gql`
  mutation savePartnerConsents($input: SavePartnerConsentsInput) {
    savePartnerConsents(input: $input) {
      commandId
      correlationId
    }
  }
`;
